module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": _vm.spinnerText
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_c('svg', {
    attrs: {
      "width": "59px",
      "height": "49px",
      "viewBox": "0 0 59 49",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Page 1")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "01_Tone_Home_Unauthenticated",
      "transform": "translate(-665.000000, -1737.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-7-Copy-2",
      "transform": "translate(88.000000, 1726.000000)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M720.393793,1779.55672 L720.248873,1779.68175 C715.432452,1783.90429 709.738162,1785.73139 704.609017,1784.72833 C699.982965,1783.81053 696.672699,1780.75588 693.478531,1777.80351 C690.014703,1774.60396 686.749756,1771.58336 681.933407,1771.06622 C677.116986,1770.54906 671.859885,1772.76828 667.705503,1777.21247 C669.319536,1779.4601 677.002852,1788.69794 689.528558,1781.06846 C689.863862,1780.92922 690.250312,1781.05993 690.432178,1781.3725 C690.616881,1781.68791 690.540158,1782.08858 690.256,1782.31308 C686.488104,1784.60333 683.098184,1785.47 680.137377,1785.47 C671.226296,1785.47 666.177169,1777.64134 666.111699,1777.53368 C665.938366,1777.25805 665.969624,1776.90286 666.185578,1776.66134 C670.717863,1771.5693 676.494789,1769.01454 682.035663,1769.61148 C687.332264,1770.17979 690.932195,1773.51009 694.402061,1776.72667 C697.587427,1779.63641 700.599445,1782.45806 704.824752,1783.27358 C709.510453,1784.20557 714.752788,1782.48934 719.214148,1778.55944 L719.387481,1778.41452 L719.390325,1778.41452 C719.95579,1777.95987 720.4985,1777.47395 721.012869,1776.95965 C718.830564,1771.81079 712.885963,1770.61729 711.700971,1770.41273 C709.538525,1771.73688 707.199966,1772.74845 704.753384,1773.41624 C704.688023,1773.42477 704.622671,1773.42477 704.557318,1773.41624 C704.364097,1773.44182 704.168024,1773.39067 704.014586,1773.27132 C703.858304,1773.15481 703.756004,1772.97864 703.730428,1772.78542 C703.676438,1772.38476 703.957751,1772.01535 704.361252,1771.96138 C711.774544,1769.85298 716.363933,1765.82932 718.023212,1760.01544 L718.020368,1760.01544 C718.710864,1757.52906 718.84157,1754.92055 718.406818,1752.37737 C708.347844,1751.34303 704.105442,1757.36146 703.479848,1758.34175 C702.920065,1762.26874 701.13838,1766.18423 698.154804,1770.03746 L698.154804,1770.0403 C697.901904,1770.33014 697.467153,1770.37276 697.163092,1770.13691 C696.859031,1769.90106 696.790849,1769.47199 697.00681,1769.15371 C699.916551,1765.55349 701.610092,1761.82844 702.113041,1758.08869 C702.323314,1756.53155 702.323314,1754.95447 702.113041,1753.39732 C701.152608,1746.12297 695.821891,1741.03092 694.213823,1739.64152 C685.803217,1747.42435 687.308862,1755.83277 689.090497,1760.34505 C689.749735,1761.44472 690.332228,1762.58984 690.838014,1763.76909 C691.036924,1764.1186 690.917581,1764.56476 690.56807,1764.76648 C690.218559,1764.96822 689.772402,1764.84604 689.570684,1764.49653 C688.925652,1763.47361 688.377254,1762.38813 687.933955,1761.26003 C685.314024,1756.82151 681.773452,1754.05958 677.371596,1753.03346 C675.11822,1752.51062 672.779661,1752.47652 670.5121,1752.93969 C668.409376,1759.30475 672.810941,1765.04494 672.853569,1765.10168 C673.10078,1765.41993 673.043953,1765.87741 672.728537,1766.1246 C672.410284,1766.36897 671.9528,1766.31214 671.705618,1765.99673 C671.495345,1765.72678 666.613571,1759.34753 669.267546,1752.0678 L669.267546,1752.06496 C669.34995,1751.84899 669.526127,1751.68703 669.74777,1751.62167 C672.799578,1750.91981 675.984944,1751.05621 678.968738,1752.01665 C681.949549,1752.97708 684.614872,1754.72751 686.683188,1757.07741 C685.680128,1751.88309 686.291057,1744.71102 693.718868,1738.1641 L693.716024,1738.1641 C693.985968,1737.9453 694.372418,1737.9453 694.64234,1738.1641 C694.969118,1738.36016 702.337149,1744.07167 703.573062,1753.22128 C703.689568,1754.11355 703.743558,1755.00859 703.735032,1755.90653 C705.968477,1753.55655 710.776387,1750.08705 719.16466,1751.11288 L719.161823,1751.11288 C719.457344,1751.14982 719.698874,1751.36294 719.772752,1751.64993 C719.772752,1751.78064 722.384099,1762.39415 713.416205,1769.32733 C715.976414,1769.98089 720.690557,1771.8364 722.565885,1776.8061 C722.79889,1777.38009 722.429491,1777.84611 720.392091,1779.55667 L720.393793,1779.55672 Z",
      "id": "Page-1",
      "stroke": _vm.getCorpHeaderColor,
      "fill": _vm.getCorpHeaderColor
    }
  })])])]), _vm._v(" "), _c('br'), _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Mindbody")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.getVideoSubcategories) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "interest-container work"
  }, [_c('button-group', {
    model: {
      value: (_vm.interestIndexes),
      callback: function($$v) {
        _vm.interestIndexes = $$v
      },
      expression: "interestIndexes"
    }
  }, _vm._l((_vm.getVideoSubcategories), function(interest, interestSubCategoryId) {
    return _c('checkbox', {
      key: interest.interestSubCategoryName.toString().toUpperCase(),
      staticClass: "min-padding checkbox-btn",
      style: (_vm.styleInterestObject(interest.interestSubCategoryName.toString().toUpperCase())),
      attrs: {
        "true-value": interest.interestSubCategoryName.toString().toUpperCase()
      }
    }, [_vm._v("\n                                    " + _vm._s(interest.interestSubCategoryName) + "\n                                ")])
  }), 1)], 1)]), _vm._v(" "), (_vm.getAuthMindbodyVideos && _vm.getAuthMindbodyVideos.length >= 100 && !_vm.showAllVideosFlag) ? _c('a', {
    staticClass: "bolder hidemobile",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.showAllVideos('top')
      }
    }
  }, [_vm._v("choose a category or click to see more")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [(_vm.hideCompleteList() && !_vm.isMobile) ? _c('div', [(_vm.getAuthMindbodyVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getAuthMindbodyVideos), function(video, index) {
    return ((index + 1) <= 99) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      class: {
        'private-contents': video.isPrivate === '1'
      },
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(video.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      attrs: {
        "title": video.title
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), (_vm.getAuthMindbodyVideos && _vm.getAuthMindbodyVideos.length >= 100 && !_vm.showAllVideosFlag) ? _c('a', {
    staticClass: "bolder hidemobile",
    attrs: {
      "id": "btmLink",
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.showAllVideos()
      }
    }
  }, [_vm._v("click to browse all videos")]) : _vm._e()], 2) : _vm._e()]) : _c('div', [(_vm.getAuthMindbodyVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getAuthMindbodyVideos), function(video, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      class: {
        'private-contents': video.isPrivate === '1'
      },
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(video.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      attrs: {
        "title": video.title
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(2, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  })], 2) : _vm._e()])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
}]}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-169827cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Mindbody.vue